exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "a{\r\n  text-decoration:none;\r\n  padding-bottom: 1em;\r\n}\r\n.extraSpace{\r\n  padding-bottom: 2em;\r\n}\r\n.ng-invalid.ng-touched.form-control{\r\n  border: 1px red solid;\r\n}\r\n.help-block{\r\n  color: red;\r\n  font-size: 0.7em;\r\n}\r\n.required:after {\r\n  content:\" *\";\r\n  color: red;\r\n}\r\n.explain{\r\n  margin-top: 1em;\r\n  font-size: 0.7em;\r\n}\r\n#arrivalDate, #departureDate{\r\n  width: 10em;\r\n  display: inline-block;\r\n}\r\n#arrivalDateBtn, #departureDateBtn{\r\n  margin-bottom: .2em;\r\n}\r\n.noStrong {\r\n  font-weight: lighter;\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/rzonsol/WebstormProjects/ammpb2/src/app/form/form.component.css
// module id = ../../../../../src/app/form/form.component.css
// module chunks = main